import React from "react";
import "./about.css";

import Enroll from "../enroll";

const About = () => {
  return (
    <>
      <Enroll />
    </>
  );
};

export default About;
